import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import queryString from 'query-string';

import { RAIL_CAPTCHA_PATH } from "../../constants/URLconstants";
import BookingDetails from "./components/BookingDetails";
import { config, LABELS, useViewport, service } from "./utils";
import { Button, ComponentSwitcher, Modal, Title } from "./components";

const NeedHelpPage = ({ location, history }) => {
  const [options, updateOptions] = useState(config.HELP_OPTION_LIST);
  const [modalState, setModalState] = useState({
    show: false,
    currentModal: undefined
  });

  const toggleModal = () =>
    setModalState({
      show: false,
      currentModal: undefined
    });

  const updateCurrentModal = currentModal => {
    setModalState({
      show: true,
      currentModal
    });
  };

  const handleClick = item => {
    const { linkedPage, pageId } = item;
    if (linkedPage) return;
    updateOptions(
      options.map(item => {
        if (item.pageId === pageId) {
          return {
            ...item,
            isActive: !item.isActive
          };
        }
        return item;
      })
    );
  };

  const handleContinueButonClick = () => {
    service.trackClick(config.NEED_HELP_TRACKING.NEED_HELP, config.CTA_TRACKING_ID.CONTINUE_BOOKING);
    const queryParams = queryString.parse(location.search);
    history.push(`${RAIL_CAPTCHA_PATH}/?mmtId=${queryParams.mmtId}`);
  }

  const { width, breakpoint } = useViewport();
  useEffect(()=> {
    service.trackPage(config.NEED_HELP_TRACKING.NEED_HELP); 
  }, [])

  return (
    <React.Fragment>
      {width < breakpoint && <BookingDetails />}

      <div className="containerMain">
        <div className="container__left">
          {options.map(item => {
            return (
              <div
                key={item.pageId}
                className={`needHelpTile ${
                  item.isActive ? "needHelpTileExp" : ""
                }`}
              >
                <Title
                  item={item}
                  handleClick={handleClick}
                  updateCurrentModal={updateCurrentModal}
                />
                {item.isActive ? (
                  <ComponentSwitcher pageId={item.pageId} />
                ) : null}
              </div>
            );
          })}
        </div>
        {width > breakpoint && (
          <div className="container__right">
            <BookingDetails customClass="appendBottom20" />
            <Button
              label={LABELS.CONTINUE_BOOKING}
              onClick={handleContinueButonClick}
              className="needHelp__fullWidthBtn"
            />
          </div>
        )}
        {width < breakpoint && (
          <div className="needHelpBtnMweb">
            {" "}
            <Button
              label={LABELS.CONTINUE_BOOKING}
              onClick={handleContinueButonClick}
              className="needHelp__fullWidthBtn"
            />
          </div>
        )}

        <Modal
          show={modalState.show}
          setShow={toggleModal}
          currentModal={modalState.currentModal}
        />
      </div>
    </React.Fragment>
  );
};

export default withRouter(NeedHelpPage);
